import './Loader.css'

const Loader = () =>{
return(
    <div className='lds-roller-container'>
        <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
)}

export default Loader